/**
 * Returns a boolean stating if the app is in beta.
 */
export const useBeta = (): boolean => {
  const isBeta = JSON.parse(import.meta.env.VITE_IS_BETA || 'true');
  return isBeta;
};
